import { ActivityType } from '@/api/types/renewal';

export const courseCreditsData = {
  renewalEntries: [
    {
      //banner展示
      activityId: '',
      activityZhName: '',
      activityEnName: '',
      subjects: 'CHINESE',
      activityType: '',
      mobileZhUrl: '',
      mobileEnUrl: '',
      webZhUrl: '',
      webEnUrl: '',
    },
  ],
  courseCreditsEntries: {
    //学时部分

    english: {
      activityId: '',
      activityZhName: '',
      activityEnName: '',
      subjects: 'ENGLISH',
      activityType: '',
      mobileZhUrl: '',
      mobileEnUrl: '',
      webZhUrl: '',
      webEnUrl: '',
    },

    math: {
      activityId: '',
      activityZhName: '',
      activityEnName: '',
      subjects: 'MATH',
      activityType: '',
      mobileZhUrl: '',
      mobileEnUrl: '',
      webZhUrl: '',
      webEnUrl: '',
    },

    // "chinese": {
    //   "activityId": "",
    //   "activityZhName": "",
    //   "activityEnName": "",
    //   "subjects": "CHINESE",
    //   "activityType": "",
    //   "mobileZhUrl": "",
    //   "mobileEnUrl": "",
    //   "webZhUrl": "",
    //   "webEnUrl": ""
    // }
  },
};

export const calendarEntryData = {
  renewalEntries: [
    //课表页续费入口
    {
      activityId: '123123',
      activityZhName: '',
      activityEnName: '',
      subjects: 'CHINESE',
      activityType: '',
      mobileZhUrl: '',
      mobileEnUrl: '',
      webZhUrl: '',
      webEnUrl: '',
    },
  ],
};

export const homeEntryData = {
  normalEntry: {
    // 首页常规入口
    activityId: '1',
    activityZhName: '',
    activityEnName: '',
    subjects: ['CHINESE', 'MATH', 'ENGLISH'],
    activityType: '',
  },
  renewalEntries: [
    {
      activityId: '63978950-c574-400b-afe4-30b374cdada5',
      activityZhName: '🎉周年特惠课包-续费',
      activityEnName: '🎉Anniversary Special Package - Renewal',
      subjects: ['CHINESE', 'MATH', 'ENGLISH'],
      activityType: 'RENEWAL',
      activityStatus: 'ON',
      mobileZhUrl:
        'https://test.cdnwukong.com/9d1e73d2-c032-41b6-9907-2296f494ac31/ba7ddad9-26c7-4e1a-86a2-23491079cd07/3.png',
      mobileEnUrl:
        'https://test.cdnwukong.com/9d1e73d2-c032-41b6-9907-2296f494ac31/21997a03-894e-49af-98c8-2bffcbcb1cd3/4.png',
      webZhUrl:
        'https://test.cdnwukong.com/9d1e73d2-c032-41b6-9907-2296f494ac31/868f189d-247d-4b1a-a337-f347753d2278/2.png',
      webEnUrl:
        'https://test.cdnwukong.com/9d1e73d2-c032-41b6-9907-2296f494ac31/ed853966-eabb-4e57-b863-255a3d41a467/1.png',
      startTime: '2025-05-28T18:11:49',
      expireTime: '2025-06-08T18:48:56',
    },
    {
      activityId: '63978950-c574-400b-afe4-30b374cdada6',
      activityZhName: '🎉周年特惠课包-续费',
      activityEnName: '🎉Anniversary Special Package - Renewal',
      subjects: ['CHINESE', 'MATH', 'ENGLISH'],
      activityType: 'RENEWAL',
      activityStatus: 'ON',
      mobileZhUrl:
        'https://test.cdnwukong.com/9d1e73d2-c032-41b6-9907-2296f494ac31/ba7ddad9-26c7-4e1a-86a2-23491079cd07/3.png',
      mobileEnUrl:
        'https://test.cdnwukong.com/9d1e73d2-c032-41b6-9907-2296f494ac31/21997a03-894e-49af-98c8-2bffcbcb1cd3/4.png',
      webZhUrl:
        'https://test.cdnwukong.com/9d1e73d2-c032-41b6-9907-2296f494ac31/868f189d-247d-4b1a-a337-f347753d2278/2.png',
      webEnUrl:
        'https://test.cdnwukong.com/9d1e73d2-c032-41b6-9907-2296f494ac31/ed853966-eabb-4e57-b863-255a3d41a467/1.png',
      startTime: '2025-05-28T18:11:49',
      expireTime: '2025-06-08T18:48:56',
    },
  ],
};

export const activityDetailRes = {
  uuid: '1',
  activityEnName: 'Exclusive Sale: Up to 15% Off on Top Brands Limited Time Only!',
  activityEnDescription:
    'Spring is the season of rejuvenation for all things, and it is also the perfect time to spark creativity and inspiration. To allow more people to experience the charm of handmade crafts and the joy of creation, we have specially planned the "Spring Market · Creative Handmade Experience Day" event. ',
  activityZhName: '活动促销：国际中文课程最高可享受15%的限时折扣！',
  activityZhDescription:
    '春天是万物复苏的季节，也是激发创造力和灵感的最佳时机。为了让更多人体验手工艺品的魅力和创造的乐趣，我们特别策划了“春季市场·创意手工体验日”活动。为了让更多人体验手工艺品的魅力和创造的乐趣，我们特别策划了“春季市场·创意手工体验日”活动。',
  activityType: ActivityType.RENEWAL,
  activityTag: 'Most Popular',
  expireTime: '2025-05-21 16:00:00', //
  activityStatus: 'ON',
  activityId: '1111',
  startTime: '2025-05-16 16:00:00',

  teacherInfo: {
    uuid: '',
    teacherNameZh: '小红',
    teacherNameEn: 'xiaohong',
    teacherImage: '',
  },

  academicSummary: {
    totalCompleted: 2, //累计完课
    totalLearningHours: 0, //累计上课时长
    trophiesEarned: 0, //课堂奖杯数
    homeworkSubmitNum: 2, //提交作业次数
    homeworkCorrectAnswersNum: 2, //正确答题数量（作业）
    homeworkCorrectRate: 2, //作业答题正确率
    totalSpeekTime: 2, //累计开口时长
    avgParticipationRateInClass: 2, //课中互动题参与率均值
    avgAccuracyRateInClass: 0, //课堂互动题正确率均值
    totalEssaysCompletedNum: 2, //累计完成作文数量
    avgEssayScore: 2, //作文平均得分（星级）
  },

  skuList: [
    {
      uuid: '',
      packageZhName: '这里产品是说后台会限制字符，中文9个字符，英文15个字符',
      packageEnName: 'Mastery title',
      price: {
        value: 100,
        currency: 'USD',
      }, //价格
      originalPrice: {
        value: 100,
        currency: 'USD',
      }, //划线价格
      discountRate: {
        percent: 1,
        currency: 'USD',
      }, //有汇率
      standardLessons: 100, //标准课时
      giftLessonsNumber: 30, //赠送课时
      paymentIn24hBonusLessons: 30, //24小时支付赠送课时
      activitySkuTag: 'Most Popular',
      courseCredits: 500,
    },
  ],

  activityZhRules:
    '购买的课程和独家免费课程将在付款后直接计入总课程数。此次续费成功后，有效期将叠加。所有课程（包括免费课程）和福利必须在有效期内使用完毕。点击这里（跳转到APP课程有效期栏目）查看您的课程有效期。退款需扣除已上课的费用、教材费用和礼品费用（如有）以及退款金额的3%手续费。详情请参见发票和服务条款。',
  activityEnRules:
    'Purchased lessons and exclusive free lessons will be directly included in the total lessons after payment. After this renewal is successful, the validity period will be superimposed. All courses (including free fruits) and benefits should be used up within the validity period. Click here (jump to the APP lesson validity period column) to check your lesson validity period.Refunds need to deduct the fees for lessons already taken, the fees for teaching materials and gifts (if any) and the handling fee of 3% of the refund amount. For details, please see the Invoice and Terms of Service.',
};

// export const activityDetailRes = {}

export const cardDetailRes = {
  learningGoalEn: '',
  learningGoalZh: '44444434',
  levels: [
    { zone: 'MK', position: 1, type: 'PRE_VIEW' },
    { zone: 'MK', position: 2, type: 'PRE_VIEW' },
    { zone: 'G', position: 1, type: 'PRE_VIEW' },
    { zone: 'H', position: 1, type: 'PRE_VIEW' },
    { zone: 'Y', position: 1, type: 'PRE_VIEW' },
    { zone: 'Y', position: 1, type: 'NOW' },
  ],
  learningSummary: {
    // 中文
    chinese: {
      characters: { min: 22, max: 50 },
      words: { min: 23, max: 50 },
      sentences: { min: 2, max: 50 },
      rhymesAndPoems: { min: 50, max: 50 },
      texts: { min: 33, max: 50 },
      writingPractice: { min: 34, max: 100 },
    },

    //数学
    math: {
      number: { min: 30, max: 50 },
      geometry: { min: 30, max: 50 },
      problem: { min: 30, max: 150 },
      reasoning: { min: 30, max: 50 },
      probability: { min: 30, max: 50 },
    },
    //英文
    english: {
      extendingVocabulary: { min: 90, max: 100 },
      genre: { min: 30, max: 100 },
      vocabulary: { min: 30, max: 100 },
      grammar: { min: 30, max: 100 },
      readingStrategy: { min: 30, max: 0 },
      writingTraits: { min: 30, max: 0 },
      languageGems: { min: 50, max: 200 },
    },
  },
};
